<template>
  <v-text-field
    :id="id"
    :label="inputLabel"
    v-model="valorInterno"
    :prepend-icon="prependIcon"
    :disabled="disabled"
    :required="required"
    :rules="[rules.requiredNome, rules.numeroValido, rules.intervaloValido]"
    @input="numeroAlterado"
    type="Number">
  </v-text-field>
</template>
<script>
export default {
  name: 'InputNumber',
  props: {
    value: {
      type: [Number],
    },
    prependIcon: {
      type: String,
      default: 'filter_1',
    },
    label: {
      type: String,
      default: 'Default label',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    max: Number,
    min: Number,
    id: {
      type: String,
      default: () => {
        const hash = Math.floor(Math.random() * 1000) + 1;
        return `input-number-${hash}`;
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(alterado) {
        this.valorInterno = alterado;
      },
    },
  },
  computed: {
    inputLabel() {
      return `${this.label} ${this.required ? '*' : ''}`;
    },
  },
  data() {
    return {
      valorInterno: null,
      rules: {
        requiredNome: () => {
          if (!this.required) {
            return true;
          }
          const msg = this.$t('message.campo_obrigatorio');
          const val = this.valorInterno;
          return !!(val) || msg;
        },
        numeroValido: () => {
          if (!this.valorInterno) return true;

          const msg = this.$t('message.numero_invalido');
          const val = this.valorInterno;
          return (!!(val) && !Number.isNaN(val.toString())) || msg;
        },
        intervaloValido: () => {
          if (!this.valorInterno) return true;

          const { max, min } = this;
          if (!max || !min) {
            return true;
          }

          const msg = this.$t('message.intervalo_numerico', { max, min });
          const val = this.valorInterno;
          return (!!(val) && val <= max && val >= min) || msg;
        },
      },
    };
  },
  methods: {
    numeroAlterado(valor) {
      const numero = Number(valor);
      this.$emit('InputNumber_valorAlterado', numero);
      this.$emit('input', numero);
    },
  },
};
</script>
